import { render, staticRenderFns } from "./addmerchant.vue?vue&type=template&id=5a6f9c03&scoped=true&"
import script from "./addmerchant.vue?vue&type=script&lang=js&"
export * from "./addmerchant.vue?vue&type=script&lang=js&"
import style0 from "./addmerchant.vue?vue&type=style&index=0&id=5a6f9c03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6f9c03",
  null
  
)

export default component.exports